import useCurrentCompany from "./current-company"

export default function useCurrentCompanyMetadata() {
  const company = useCurrentCompany()
  const metadata = company?.metadata ?? {}

  return metadata
}
